var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showOrderReport)?_c('div',{staticClass:"fixed-btn"},[_c('img',{attrs:{"src":require("@/assets/img/orderReport/order-report.png")},on:{"click":_vm.toPage}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }